import angular from 'angular';
import {WhatsappConnectController} from './connect.controller.js';
import {WhatsappPreVerifyController} from './pre-verify.controller.js';
import {WhatsappVerifyController} from './verify.controller.js';

angular.module('parameters.addAccountWhatsapp', [])
    .controller('WhatsappConnectController', WhatsappConnectController)
    .controller('WhatsappPreVerifyController', WhatsappPreVerifyController)
    .controller('WhatsappVerifyController', WhatsappVerifyController);
